import {
  AdminImageInput,
  AdminInput,
  Button,
  Div,
  H3,
  Modal,
  P,
  PropsModal,
  SuccessToast,
  deleteBrandFooterImage,
  lightTheme,
  updateBrandPrintingSettings,
  reportError,
} from '@vgrubs/components';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { FooterMessageResponse } from 'components/src/types/api/brand.types';

export const BrandFooterMessageModal = ({
  modalIsOpen,
  closeModal,
  setLoading,
  data,
  id,
}: PropsModal & {
  modalIsOpen: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
  data: FooterMessageResponse | null;
  id: number | null;
}) => {
  const [message, setMessage] = useState('');
  const [image, setImage] = useState<File | Blob | string | null>(null);
  const [deleteImageModal, setDeleteImageModal] = useState(false);

  useEffect(() => {
    if (data) {
      setMessage(data.message ?? '');
      setImage(data.image ?? null);
    }
  }, [data]);

  async function handleBrandFooterMessage() {
    if (message === data?.message && (image === data?.image || !image)) {
      return closeModal?.();
    }

    const body = {
      message,
    };
    try {
      setLoading(true);

      const formData = new FormData();

      if (typeof image !== 'string' && image !== null) {
        formData.append('image', image);
      }

      formData.append('printingData', JSON.stringify(body));

      const { data } = await updateBrandPrintingSettings(
        id as number,
        formData
      );

      SuccessToast(data.message);
      closeModal?.();

      setLoading(false);
    } catch (error) {
      reportError(error);
      setLoading(false);
    }
  }

  async function handleDeleteImage() {
    try {
      setLoading(true);
      const { data } = await deleteBrandFooterImage(id as number);
      setImage(null);
      SuccessToast(data.message);
      setDeleteImageModal(false);
      setLoading(false);
    } catch (error) {
      reportError(error);
      setLoading(false);
    }
  }

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        closeModal={closeModal}
        logo={false}
        header="Printing Settings"
      >
        <Div $mb="24">
          <AdminImageInput
            image={image}
            onChange={(img: File | Blob | string | null) => setImage(img)}
            label="Footer Image"
            onDelete={() => setDeleteImageModal(true)}
          />
        </Div>

        <AdminInput
          label="Footer Message"
          type="textarea"
          placeholder="Enter your message here.."
          value={message}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
            setMessage(e.target.value)
          }
        />

        <Button $selected $w="100%" $mt="40" onClick={handleBrandFooterMessage}>
          Update
        </Button>
      </Modal>

      <Modal
        isOpen={deleteImageModal}
        closeModal={() => setDeleteImageModal(false)}
        logo={false}
        zIndex={110}
      >
        <H3 $mb="24" $color={lightTheme.primary}>
          Are you sure
        </H3>
        <P $mb="40">Are you sure you want to delete footer image?</P>

        <Button $selected $w="100%" $mb="8" onClick={handleDeleteImage}>
          Confirm
        </Button>

        <Button
          $selected
          $w="100%"
          $gray
          onClick={() => setDeleteImageModal(false)}
        >
          Cancel
        </Button>
      </Modal>
    </>
  );
};
